import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import Support from '../../../shared/Support';
import ReturnToMerchant from '../../../shared/ReturnToMerchant';

export default function Recharge({ merchant }) {
  return (
    <>
      <div className="is-size-4 has-text-weight-bold mb-4">
        <p className="ck-blue is-size-1">
          <FontAwesomeIcon icon={['far', 'thumbs-up']} />
        </p>

        You're good to go!
      </div>

      <div className="columns">
        <div className="column is-centered">
          <div style={{ maxWidth: "400px", margin: "0 auto", lineHeight: "30px", marginBottom: "30px" }}>
            <p>
              Your {merchant.name} rep will be able to see that you're
              now approved for Credit Key Recharge. They'll be able to
              place orders on your behalf, using your selected terms.
            </p>
          </div>
          <ReturnToMerchant merchant={merchant} />
          <Support />
        </div>
      </div>
    </>
  );
}
